import { Button, CircularProgress } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import OpenExcelUniversal from "../../../../../components/excel/OpenExcelUniversal";
import { Container, SecaoButao, } from "../../../../../components/formulario/styled";
import { IconEdit } from "../../../../../components/icons/icones";
import DonwloadPdf from "../../../../../components/pdf/DonwloadPdf";
import api from "../../../../../utils/api";
import { useNavigate } from "react-router-dom";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../../components/formulario/tableStyled";
import ModalExportar from "../../../../../components/modalExportar";
import SearchInput from "../../../../../components/inputs/searchInput";


export type T_celula = {
  id: string,
  nomesede: string,
  nomeministerio: string,
  descricao: string,
  cep: string,
  endereco: string,
  frequencia: string,
  bairro?: string
}

export default function ContainerCelulaPg() {

  const [pesquisaPorCep, setPesquisaPorCep] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const [dado, setDado] = useState<any[]>([]);
  const [filas, setFilas] = useState({ fila: 0, tamanho: 300 });
  const devRef = useRef<HTMLElement | null>(null);

  const router = useNavigate();

  useMemo(() => {
    setLoading(true);
    api.get('/ministerio/celula/v2/listar')
      .then(
        da => {
          setDado(da.data);
          setLoading(false);
          return;
        }
      )
      .catch(
        er => { setLoading(false); alert(er); }
      )
  }, []);

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          setFilas({ fila: filas.fila++, tamanho: filas.tamanho + 300 })
        }
      })
    }
  }, [devRef])

  const Td = () => <>
    {
      dado
        .filter(
          (el: T_celula) => pesquisaPorCep.length > 1 ?
            el['cep']?.match(pesquisaPorCep) || el['descricao'].normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLocaleUpperCase().match(String(pesquisaPorCep).toLocaleUpperCase())
            : true
        ).splice(0, (filas.fila + 1) * 30)
        .map(
          (linha: T_celula, key) =>
            <tr key={`chave-${key}`}>
              <td>{linha?.nomesede}</td>
              <td>{linha?.nomeministerio}</td>
              <td>{String(linha?.descricao ?? '').substring(0, 15)}</td>
              <td>{linha?.cep}</td>
              <td>{linha?.bairro}</td>
              <td>{linha?.endereco}</td>
              <td>{linha?.frequencia}</td>
              <td onClick={() => router(`./editar/${linha?.id}`)}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <IconEdit style={{ width: '20px' }} />
                </div>
              </td>
            </tr>)
    }
  </>

  return (
    <>
      <div style={{ display: "flex", flex: 1, padding: 5 }}>
        <Container>
          <SecaoButao style={{ marginBottom: 5 }}>
            <section style={{ display: 'flex', gap: 5 }}>
              <ModalExportar
                callDownloadExcel={() => OpenExcelUniversal(dado, ['nomesede', 'nomeministerio', 'descricao', 'cep', 'bairro', 'endereco', 'frequencia'])}
                callDownloadPdf={() => DonwloadPdf(dado, ['Sede', 'Ministério', 'Nome', 'Endereço', 'Bairro', 'Frequência', 'Comentário'], ['nomesede', 'nomeministerio', 'descricao', 'cep', 'bairro', 'endereco', 'frequencia'], dado?.length, [], `${dado?.length}`)}
              />
            </section>
            <section>
              <SearchInput
                type="text"
                aria-labelledby="campo-pesquisa-por-cep-ou-nome-pg"
                placeholder="Pesquise por CEP ou Nome"
                onChange={(e) => setPesquisaPorCep(e.target.value.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))}
                value={pesquisaPorCep}
              />
            </section>
            <section style={{ display: 'flex', gap: 5 }}>
              <Button
                variant="contained"
                sx={{
                  boxShadow: "none"
                }}
                aria-labelledby="botão-ação-criar-pg"
                onClick={() => router('add')}
              >
                Criar
              </Button>
            </section>
          </SecaoButao>
          <Tabler>
            <CorpoTable
              /*@ts-ignore*/
              ref={
                devRef
              }>
              {
                loading ?
                  <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    < CircularProgress />
                  </div> :
                  <>
                    <Tabela>
                      <TabelaCabeca>
                        <tr>
                          <th>Sede</th>
                          <th>Ministério</th>
                          <th>Nome</th>
                          <th>CEP</th>
                          <th>Bairro</th>
                          <th>Endereço</th>
                          <th>Frequência</th>
                          <th></th>
                        </tr>
                      </TabelaCabeca>
                      <TabelaCorpo>
                        <Td />
                      </TabelaCorpo>
                    </Tabela>
                  </>
              }
            </CorpoTable>
          </Tabler>
        </Container>
      </div>
    </>
  )
}
